import { objectToFormData } from "../../lib/bandung/api/helpers";
import { getPrefix, getSessionToken } from "../../lib/bandung/bandung";
import Axios from "axios";

const getContactPrefix = () => `${getPrefix()}/app/contact`;
const getContactCreateEndPoint = () => `${getContactPrefix()}/create`;

export const contactCreate = async ({
  useSessionInfo,
  firstName,
  lastName,
  email,
  phone,
  request,
  status,
  longDescription,
}) => {
  const form = objectToFormData({
    sessionToken: useSessionInfo ? getSessionToken() : null,
    firstName: firstName,
    lastName: lastName,
    email: email,
    phone: phone,
    request: request,
    status: status,
    longDescription: longDescription,
  });
  try {
    const response = await Axios.post(getContactCreateEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Contact successfully created.",
        data: { contactEntityId: response.data.contactEntityId },
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};
